import { toast } from "sonner";
import { isDemoMode } from "./demoMode";

/**
 * In the public demo, blocked actions (settings, sign out) explain why instead
 * of running. Outside the demo the action runs as normal.
 */
export const guardDemoAction = <Args extends unknown[]>(action?: (...args: Args) => void | Promise<void>) =>
  (...args: Args) => {
    if (isDemoMode()) {
      toast.info("Read-only demo", {
        description: "Settings and account actions are turned off here. Start a free trial to use them.",
      });
      return;
    }
    return action?.(...args);
  };
